import { ref } from 'vue';
import type { ChangePasswordData } from '../../types';
import { useStrapiPost } from 'src/shared/composables/useStrapiApi';
import { t } from 'boot/i18n';
import { Notify } from 'quasar';
import { mdiCheckCircle } from '@quasar/extras/mdi-v7';

const changePasswordData = ref<ChangePasswordData>();

export function useSettingsSecurity() {
  changePasswordData.value = {
    currentPassword: '',
    password: '',
    passwordConfirmation: '',
  };

  async function changePassword() {
    if (!changePasswordData.value) return;

    const { execute, data, error } = useStrapiPost(
      'auth/change-password',
      changePasswordData.value,
    );

    await execute();

    if (error.value) throw new Error(error.value as string);
    if (!data.value) throw new Error('Failed to update password');
    Notify.create({
      type: 'positive',
      message: t('PASSWORD_UPDATED'),
      position: 'bottom',
      icon: mdiCheckCircle,
    });
  }

  return {
    changePasswordData,
    changePassword,
  };
}
